import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Button, Tooltip } from "antd";
import { SET_LANG } from '@/store/reducers/lang';
import { Check, Languages } from "lucide-react";
import { defaultColors } from '@/themes/antd-theme';
import { useTheme } from '@/App';

const LanguageSelector = () => {
  const { isDark } = useTheme();
  const lang = useSelector((state) => state.lang);
  const dispatch = useDispatch();

  // Available languages
  const languages = [
    { code: "en", label: "English" },
    { code: "hi", label: "हिंदी" },
    { code: "mr", label: "मराठी" },
    { code: "thai", label: "ภาษาไทย" },
    { code: "ar", label: "العربية" },
  ];

  // Handle language change
  const handleSelect = ({ key }) => {
    dispatch(SET_LANG(key));
  };

  // Build items for Ant Design v5 Dropdown
  const items = languages.map((l) => ({
    key: l.code,
    label: (
      <span className="flex justify-between items-center">
        {l.label}
        {lang === l.code && <Check size={16} style={{ color: defaultColors.primary }} />}
      </span>
    ),
  }));

  // Dark mode aware colors
  const bgColor = isDark ? defaultColors.grey[700] : defaultColors.grey[100];
  const iconColor = isDark ? defaultColors.grey[100] : defaultColors.grey[700];

  return (
    <Dropdown
      menu={{ items, onClick: handleSelect, selectedKeys: [lang] }}
      trigger={["click"]}
      placement="bottomRight"
      overlayStyle={{ zIndex: 2000, width: 120 }}
    >
      <Tooltip title="Language" zIndex={9999}>
        <Button
          type="text"
          shape="circle"
          icon={
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Languages size={22} style={{ display: 'block', color: iconColor }} />
            </div>
          }
          style={{
            backgroundColor: bgColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
          }}
          onClick={(e) => e.preventDefault()}
          aria-label="open language selector"
          aria-haspopup="true"
        />
      </Tooltip>
    </Dropdown>
  );
};

export default LanguageSelector;
